import { tableSchema } from '@nozbe/watermelondb';

import type { ITable } from './interface';

export const sampleToAnswerTable = {
  name: 'samples_to_answers',
  columns: [
    {
      name: 'answer_id',
      type: 'number',
    },
    {
      name: 'sample_id',
      type: 'number',
    },
    {
      name: 'order',
      type: 'number',
      isOptional: true,
    },
    {
      name: 'created_by',
      type: 'string',
    },
    {
      name: 'updated_by',
      type: 'string',
    },
    {
      name: 'created_at',
      type: 'number',
    },
    {
      name: 'updated_at',
      type: 'number',
    },
  ],
} as ITable;

export const sampleToAnswerSchema = tableSchema(sampleToAnswerTable);
